import React from "react";
import Slider from "./slieder";
import { motion } from "framer-motion";
import FooterwithoutLogin from "./footerwithoutLogin";
import SEO from "../SEO/seo";

function DutchBucket() {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  };

  const scaleFade = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1 },
  };

  const imageZoom = {
    hidden: { scale: 1.05, opacity: 0 },
    visible: { scale: 1, opacity: 1 },
  };

  const slideLeftToRight = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 },
  };

  const slideRightT0Left = {
    hidden: { opacity: 0, x: 100 },
    visible: { opacity: 1, x: 0 },
  };
  return (
    <>
      <SEO
        title="Dutch Bucket Hydroponic | Kryzen Hydroponic Systems"
        description="Hydroponic Dutch Bucket (Bato Bucket) system is ideal for growing large plants like tomatoes, cucumbers, peppers, and squash. Scalable and efficient, it's perfect for both commercial greenhouses and home setups."
        keywords="dutch bucket hydroponic, bato bucket system, hydroponic tomatoes, hydroponic peppers, kryzen hydroponics, vine crop hydroponics, scalable hydroponic system, commercial greenhouse hydroponics"
        canonical="https://alpha.kryzen.com/kryzen-dutch-buckets"
        ogTitle="Dutch Bucket Hydroponic | Kryzen Hydroponic Systems"
        ogDescription="Discover Kryzen's Dutch Bucket (Bato Bucket) hydroponic system — a scalable solution for growing large crops like tomatoes and cucumbers in commercial and home gardens."
        ogImage="https://res.cloudinary.com/bsgfcooa/image/upload/v1752297910/60_srwnm0.jpg"
        twitterTitle="Dutch Bucket Hydroponic | Kryzen Hydroponic Systems"
        twitterDescription="Kryzen’s Dutch Bucket hydroponic system is perfect for growing tomatoes, peppers, and vine crops. Scalable, simple, and ideal for commercial or home use."
      />
      <div>
        <Slider
          heding={"dutch bucket hydroponic"}
          paragraph={
            "Hydroponic Dutch Bucket (also known as the Bato bucket system) is a popular and effective hydroponic method used primarily for growing larger plants such as tomatoes, cucumbers, peppers, and even vine crops like squash. It is widely used in both commercial greenhouses and small-scale home gardens due to its simplicity and scalability."
          }
        ></Slider>
        <div className="container mainDiv py-5">
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-5 fw-bold text-uppercase text-success mb-2"
            >
              kryzen dutch bucket hydroponic
            </motion.h1>

            <hr></hr>
            <motion.p
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="lead mx-auto p-5"
              style={{ lineHeight: "1.8", fontSize: "25px" }}
            >
              Hydroponic Dutch Bucket (also known as the Bato bucket system) is
              a popular and effective hydroponic method used primarily for
              growing larger plants such as tomatoes, cucumbers, peppers, and
              even vine crops like squash. It is widely used in both commercial
              greenhouses and small-scale home gardens due to its simplicity and
              scalability.
            </motion.p>
          </div>
          <div className="row g-5 align-items-stretch mt-7">
            {/* Left Column */}
            <div className="col-md-4">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideLeftToRight}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147218/mainframe_totggg.jpg"
                  alt="What is a Polyhouse?"
                  className="card-img-top img-fluid"
                  style={{ width: "100%", height: "300px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Main Frame Material
                  </h5>
                  <motion.p
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                  >
                    Constructed from high-quality hot-dip galvanized steel, our
                    structure boasts a Zinc-coating of 275g/m2, ensuring a
                    robust service life of over 20 years. The steel components
                    are assembled on-site without needing secondary processing.
                    Galvanized connectors and fasteners are designed to resist
                    rust for two decades, guaranteeing long-term durability and
                    reliability.
                  </motion.p>
                </div>
              </motion.div>
            </div>

            <div className="col-md-4">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={scaleFade}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147339/out_ddbqic.webp"
                  alt="Grrenhouse Benefits"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "300px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Covering Materials
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Our covering materials made up of LDPE, mLLDPE, EVA, EBA
                    with a tensile strength of 25 MPa offer excellent light
                    transmission, superior heat preservation, and strong tensile
                    strength. They provide economical rain, wind & sun
                    protection to plants, with a lifespan of 5-7 years, ensuring
                    cost-effectiveness without compromising on quality.
                  </motion.p>
                </div>
              </motion.div>
            </div>

            {/* Right Column */}
            <div className="col-md-4">
              <motion.div
                className="card border-0 h-100"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.3 }}
                variants={slideRightT0Left}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <motion.img
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: false, amount: 0.3 }}
                  variants={imageZoom}
                  transition={{ duration: 0.6 }}
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752147630/nvph_knv1je.webp"
                  alt="Grrenhouse Benefits"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "300px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Outside Shading System
                  </h5>
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="card-text text-secondary"
                    style={{ lineHeight: "1.8", fontSize: "1.05rem" }}
                  >
                    Engineered to provide optimal cooling and shading during the
                    summer, this system diffuses sunlight within the greenhouse,
                    effectively shielding crops from harmful sun glare and
                    ensuring consistent growth conditions. Shading systems are
                    utilized widely when you want to grow crops which are
                    locally climatically affected.
                  </motion.p>
                </div>
              </motion.div>
            </div>
          </div>
          <div className="text-center py-5 px-3">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase mt-7"
            >
              Product Parameters DUTCH BUCKET
            </motion.h1>

            <hr></hr>
          </div>
          <div
            className=" py-5"
            style={{
              background:
                "color-mix(in srgb,rgb(255, 208, 143) 10%, transparent)",
              color: "black",
              border: `1px solid color-mix(in srgb, #f59f00 20%, transparent)`,
              padding: "1rem",
              borderRadius: "0.25rem",
            }}
          >
            <div className="row">
              <div className="col-md-6 mb-2">
                <div
                  className="card border-0 shadow-sm h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add("shadow-lg");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.classList.remove("shadow-lg");
                  }}
                >
                  <img
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752297302/53_b1z5hq.jpg"
                    alt="HEAT TRAPPING CARBONATE"
                    className="card-img-top img-fluid p-2"
                    style={{ width: "100%", height: "380px" }}
                  />
                  {/* <div className="card-body p-4">
                    <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                      HEAT TRAPPING CARBONATE
                    </h5>
                  </div> */}
                </div>
              </div>

              <div className="col-md-6">
                <div
                  className="card border-0 shadow-sm h-100"
                  onMouseEnter={(e) => {
                    e.currentTarget.classList.add("shadow-lg");
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.classList.remove("shadow-lg");
                  }}
                >
                  <img
                    src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752297302/52_xncrbk.jpg"
                    alt="HEAT TRAPPING CARBONATE"
                    className="card-img-top img-fluid p-2"
                    style={{ width: "100%", height: "380px" }}
                  />
                  {/* <div className="card-body p-4">
                    <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                      HEAT TRAPPING CARBONATE
                    </h5>
                  </div> */}
                </div>
              </div>

              <div className="col-12 mt-5">
                <p
                  style={{
                    fontSize: "1.05rem",
                    lineHeight: "1.8",
                    color: "#444",
                  }}
                >
                  Plastic film Polytunnel is a simple type of protected
                  cultivation tunnelled greenhouse, which uses transparent
                  plastic films made of polymer materials such as polyethene and
                  polypropylene and connects each arch greenhouse into a whole
                  through the method of connecting wires and buildings. The
                  multi-span polytunnel or greenhouse connects the original
                  independent greenhouse with the original independent single
                  room model greenhouse through reasonable design, increasing
                  the insulation area of the greenhouse and improving its
                  performance
                </p>
              </div>
            </div>
          </div>

          <div className="text-center py-5 px-3 mt-7">
            <motion.h1
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.3 }}
              variants={fadeUp}
              transition={{ duration: 0.7 }}
              className="display-md-4 display-lg-4 display-6 fw-bold text-uppercase"
            >
              Optional Intelligent Polytunnel Add-ons
            </motion.h1>

            <hr></hr>
          </div>

          <div>
            <div
              className="container  py-5"
              style={{
                background:
                  "color-mix(in srgb,rgb(204, 255, 204) 15%, transparent)",
                color: "#000",
                border: "1px solid #c0e6b6",
                borderRadius: "8px",
                padding: "1rem",
              }}
            >
              <h3 className="text-success fw-bold mb-4">
                Optional Intelligent Polytunnel Add-ons
              </h3>

              <div className="table-responsive">
                <table className="table table-bordered table-striped align-middle">
                  <thead className="table-success">
                    <tr>
                      <th style={{ width: "25%" }}>Add-on</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">Steel Structure</th>
                      <td>Hot-galvanized steel pipe</td>
                    </tr>
                    <tr>
                      <th scope="row">Greenhouse Glass</th>
                      <td>Different models can be selected</td>
                    </tr>
                    <tr>
                      <th scope="row">Sun-shading Net</th>
                      <td>
                        Summer shade, block rain, moisture, cooling,
                        winter/spring heat preservation
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Cooling System</th>
                      <td>
                        The fan forms negative pressure and the water curtain
                        cools down
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Heating System</th>
                      <td>
                        Thermal insulation series, air heater, boiler and pipe
                        heating, air circulating fan
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Ventilation System</th>
                      <td>Side windows and cooling fans</td>
                    </tr>
                    <tr>
                      <th scope="row">
                        Water & Fertilizer Integrated Irrigation System
                      </th>
                      <td>
                        Sprinkler irrigation series, drip irrigation series,
                        intelligent mobile sprinkler irrigation
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Automatic Control System</th>
                      <td>
                        Automatic control technology that can independently
                        drive intelligent machines to achieve control objectives
                        without human intervention
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Fill-in Light</th>
                      <td>
                        Easy assemble auto light deprivation blackout greenhouse
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">Seedling Bed</th>
                      <td>Movable seeding bed</td>
                    </tr>
                    <tr>
                      <th scope="row">Hydroponics</th>
                      <td>
                        It is reusable, requires no nutrient additions, and is
                        both convenient and inexpensive.
                      </td>
                    </tr>
                    <tr>
                      <th scope="row">External & Internal Shading System</th>
                      <td>The gear rack drives the shading system</td>
                    </tr>
                    <tr>
                      <th scope="row">Photovoltaic System</th>
                      <td>For solar power generation</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="row g-5 align-items-stretch mt-7">
            {/* Left Column */}
            <div className="col-md-6">
              <div
                className="card border-0 h-100"
                // onMouseEnter={(e) => {
                //   e.currentTarget.classList.add("shadow-lg");
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.classList.remove("shadow-lg");
                // }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752297910/60_srwnm0.jpg"
                  alt="What is a Polyhouse?"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "380px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    DUTCH BUCKET
                  </h5>
                  <p>
                    {" "}
                    A Dutch bucket is a popular hydroponic growing system used
                    for growing larger plants like tomatoes, peppers, cucumbers,
                    and other fruiting vegetables
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-6">
              <div>
                <div className="card-body p-4">
                  {/* <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  DUTCH BUCKET
                  </h5> */}
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                  >
                    <b>Components of Dutch Bucket:</b> <br></br>
                    <br></br>
                    <b>Buckets:</b>Typically 2-5 gallon buckets with a drainage
                    hole at the bottom. <br></br>
                    <br></br>
                    <b>Growing Medium:</b>
                    The buckets are filled with a growing medium such as
                    perlite, coco coir, or clay pebbles, which provides support
                    to the plants and retains moisture.<br></br>
                    <br></br> <b>Drip Irrigation:</b>A drip system delivers
                    nutrient-rich water to the base of each plant.<br></br>
                    <br></br>
                    <b>Drainage System:</b>Each bucket has a drain that allows
                    excess water to flow out, preventing overwatering. This
                    water is usually collected and recycled. <br></br>
                    <br></br>
                    <b>Reservoir:</b> The nutrient solution is stored in a
                    reservoir and pumped through the drip system to each bucket.
                    <br></br>
                    <br></br>
                    <b>Advantages of Dutch Bucket:</b>
                    <br></br>
                    <br></br>- Efficient water and nutrient use.<br></br>
                    <br></br> - Easy to scale for both small and large setups.
                    <br></br>
                    <br></br>- Suitable for a variety of crops.<br></br>
                    <br></br>- Reduces soil-borne diseases.
                  </motion.p>
                </div>
              </div>
            </div>

            <div className="col-md-6 mt-7">
              <div>
                <div className="card-body p-4">
                  {/* <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                  DUTCH BUCKET
                  </h5> */}
                  <motion.p
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.3 }}
                    variants={fadeUp}
                    transition={{ duration: 0.6, delay: 0.2 }}
                  >
                    <b>Components:</b> <br></br>
                    <br></br>
                    <b>Bucket or Container:</b> A 5-gallon bucket or any
                    similar-sized container with a lid. . <br></br>
                    <br></br>
                    <b>Nutrient Solution:</b>A mixture of water and nutrients
                    that provides essential elements for plant growth.<br></br>
                    <br></br> <b>Drip Irrigation:</b>A drip system delivers
                    nutrient-rich water to the base of each plant.<br></br>
                    <br></br>
                    <b>Net Pot:</b>A small pot, often made of plastic mesh, that
                    holds the plant and sits in a hole in the lid of the bucket.
                    <br></br>
                    <br></br>
                    <b>Growing Medium:</b> Typically clay pebbles, rock wool, or
                    coco coir used inside the net pot to support the plant.
                    <br></br>
                    <br></br>
                    <b>Advantages:</b>
                    <br></br>
                    <br></br>
                    <b>- Low Maintenance:</b> Once set up, there’s no need for
                    electricity or pumps, making it a very hands-off system.
                    <br></br>
                    <br></br>
                    <b>- Cost-Effective:</b>Ideal for budget-conscious gardeners
                    since it requires minimal equipment.
                    <br></br>
                    <br></br>
                    <b>- Simplicity: :</b>Easy to use, great for beginners or
                    small spaces.
                  </motion.p>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-6 mt-7">
              <div
                className="card border-0 shadow-sm h-100"
                // onMouseEnter={(e) => {
                //   e.currentTarget.classList.add("shadow-lg");
                // }}
                // onMouseLeave={(e) => {
                //   e.currentTarget.classList.remove("shadow-lg");
                // }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752297909/54_x5jpfx.jpg"
                  alt="What is a Polyhouse?"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "380px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    Kratky Bucket
                  </h5>
                  <p>
                    {" "}
                    The Kratky Bucket is a simple, passive hydroponic system
                    that doesn’t require pumps, electricity, or continuous water
                    circulation, making it one of the easiest methods for
                    beginners or small-scale growers. It’s especially good for
                    growing leafy greens, herbs, and some smaller fruiting
                    plants.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-5 align-items-stretch mt-7">
            {/* Left Column */}
            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752300132/50_fitpkr.jpg"
                  alt="KRATKY BUCKET"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "280px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    KRATKY BUCKET
                  </h5>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752300132/51_cvasja.jpg"
                  alt="BATO BUCKET"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "280px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    BATO BUCKET
                  </h5>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-4">
              <div
                className="card border-0 shadow-sm h-100"
                onMouseEnter={(e) => {
                  e.currentTarget.classList.add("shadow-lg");
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.classList.remove("shadow-lg");
                }}
              >
                <img
                  src="https://res.cloudinary.com/bsgfcooa/image/upload/v1752300132/49_kl8bq3.jpg"
                  alt="HYDROTON BALL"
                  className="card-img-top img-fluid p-2"
                  style={{ width: "100%", height: "280px" }}
                />
                <div className="card-body p-4">
                  <h5 className="card-title fs-3 fw-semibold mb-3 text-primary">
                    HYDROTON BALL
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterwithoutLogin></FooterwithoutLogin>
    </>
  );
}

export default DutchBucket;
